<script setup>
    import { ref, onBeforeMount, computed } from "vue";
    import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useFilesStore } from "@/stores/files";

    const uiStore = useUiStore();
    const filesStore = useFilesStore();
    const emit = defineEmits(["refresh"]);
    const company_id = useCompanyStore().companyId;

    let name = ref(null);
    let parent_id = ref(null);
    let isSubmitted = ref(false);

    const getModalInfo = computed(() => uiStore.modalData);
    const getModalAction = computed(() => uiStore.modalAction);

    const onSubmit = () => {
        isSubmitted.value = true;
        const data = {
            name: name.value,
            parent_id: parent_id.value,
            company_id,
        };

        filesStore.createFolder(data).then(() => {
            isSubmitted.value = false;
            resetStoreData();
            emit("refresh");
        }).catch(() => {
            isSubmitted.value = false;
        });
    };

    const resetStoreData = () =>{
        uiStore.resetModalStore();
    };

    onBeforeMount(() => {
        if(getModalInfo.value && getModalAction.value == 'create_folder' ){
            parent_id.value = getModalInfo.value.id ? getModalInfo.value.id : null;

        }
    });
</script>

<template>
    <DModal v-if="getModalAction === 'create_folder'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
        <template #title> Create new Folder </template>
  
        <template #body>
        
            <DInput label="Folder Name" :value="name" @input="name = $event.target.value" type="text" width="100%" />
    
        </template>
        <template #footer>
            <div class="w-full">
                <div class="seperator text-center"></div>
                <div class="flex mt-20 justify-center">
                    <button :disabled="!name || isSubmitted"
                    @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
                    Create <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
                    </button>
                    <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
                </div>
            </div>
      </template>
    </DModal>
  </template>
  
